<template>
    <div>
        <!-- hides for bigger data -->
        <v-expansion-panels v-if="data && JSON.stringify(data).length > 500" flat class="bg-transparent">
          <v-expansion-panel class="bg-transparent">
            <v-expansion-panel-header class="p-0">Show {{ text }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <pre :style="{whiteSpace: 'break-spaces'}">{{ data }}</pre>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- show normal data -->
        <pre v-else-if="data" class="text-dark pt-3" :style="{textWrap: 'wrap'}">{{ data }}</pre>

        <!-- no data -->
        <p v-else class="pt-3">No {{ text }} Found</p>
    </div>
</template>

<style scoped type="text/css">
  .v-expansion-panel-header {
    font-size: 14px;
  }
</style>
<script>
export default {
    props: {
        data: { default: null },
        text: { type: String, default: '' }
    }
}
</script>